// Componentes
import ItemDeNavBar from '../componentes/ItemDeNavBar'

// Interface del usuario (GUI)
import {Navbar, NavbarBrand, NavbarNav, Collapse,	NavbarToggler } from 'mdbreact';
import './BarraNav.css'
import './Layout.css'

// React
import React, {Component}  from 'react';

// Routing
// Routing react-router-dom				
// import NavLink from 'react-router-dom'
import * as rutas from '../rutas/rutas'


class BarraNav extends Component {

	constructor(props) {
		super(props)
		this.state = {
			collapse: false,
			isWideEnough: false,
			dropdownOpen: false,

			navBarItems: [
				{activo: true, ruta: rutas.INICIO, texto:'Inicio', },
				{activo: false, ruta: rutas.SERVICIOS, texto:'Servicios', },
				{activo: false, ruta: rutas.CONTACTENOS, texto:'Contáctenos', },
				{activo: false, ruta: rutas.QUIENES_SOMOS, texto:'Quiénes somos?', },
			]
		}
	}

	onClick = () => {
		this.setState({	collapse: !this.state.collapse	})
	} 

	toggle = () => {
		this.setState({dropdownOpen: !this.state.dropdownOpen})
	}
	
	onClickItem = (i) => {
		const items = this.state.navBarItems.slice(); 
    for (const j in items) {
      items[j].activo = i == j ;
    }
		this.setState({navBarItems: items});
	} 

	render () {
		return (
			<div className='row'>
				<div className='col-sm-12 '>
					<Navbar color='green darken-4' dark expand="lg" scrolling>

						<NavbarBrand href="#">
						<img src= "LogoTraquisa-200x141.png" height="75" alt=''/><span className='tit-ciqpa' >Transformaciones Químicas S.A.</span>
						</NavbarBrand>

						{ !this.state.isWideEnough && <NavbarToggler onClick = { this.onClick } />}

						<Collapse isOpen = { this.state.collapse } navbar>
								
							<NavbarNav left>

								{this.state.navBarItems.map( (item,i) => 
									<ItemDeNavBar
										activo= {item.activo}
										ruta= {item.ruta}
										texto= {item.texto}
										key= {item.texto}
										onClick= { () => this.onClickItem(i)}
									/>
								)}

							</NavbarNav>
							
						</Collapse>

					</Navbar>
				</div>
			</div>
		)
	}
}

export default BarraNav


// WEBPACK FOOTER //
// ./src/layout/BarraNav.js